export default function Logo({ size = 40, showText = false, className = "", darkBg = false }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      {/* Icon: Split square - green grab arrow + red skip X */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Black border frame */}
        <rect x="1" y="1" width="46" height="46" stroke="#0A0A0A" strokeWidth="3" fill="white" />
        {/* Diagonal split */}
        <path d="M0 0 L48 48" stroke="#0A0A0A" strokeWidth="2" />
        {/* Green grab section (top-left triangle) */}
        <path d="M2 2 L46 2 L2 46 Z" fill="#00E676" />
        {/* Red skip section (bottom-right triangle) */}
        <path d="M46 2 L46 46 L2 46 Z" fill="#FF1744" />
        {/* Bold checkmark in green zone */}
        <path
          d="M10 20 L18 28 L30 12"
          stroke="#0A0A0A"
          strokeWidth="4.5"
          strokeLinecap="square"
          strokeLinejoin="miter"
          fill="none"
        />
        {/* Bold X in red zone */}
        <line x1="28" y1="28" x2="40" y2="40" stroke="white" strokeWidth="4.5" strokeLinecap="square" />
        <line x1="40" y1="28" x2="28" y2="40" stroke="white" strokeWidth="4.5" strokeLinecap="square" />
      </svg>

      {showText && (
        <div className="font-heading font-black tracking-tighter uppercase leading-none">
          <span className="text-[#00E676]">GRAB</span>
          <span className={darkBg ? "text-white" : "text-black"}>OR</span>
          <span className="text-[#FF1744]">SKIP</span>
        </div>
      )}
    </div>
  );
}
